import {USER_CHANGED} from './actionNames';

export const resetRedux = () => {
  return {
    type: USER_CHANGED,
  };
};
